"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulletinProviderImpl = void 0;
var Utils_1 = require("../../../utils/Utils");
var BulletinProviderImpl = (function () {
    function BulletinProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.COLLECTION = 'Bulletins';
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " BulletinProviderImpl#")], args, false));
            }
        };
        this.log('BulletinProviderImpl# created!');
    }
    BulletinProviderImpl.prototype.getAllBulletin = function () {
        throw new Error('Method not implemented.');
    };
    BulletinProviderImpl.prototype.createBulletin = function (id, bulletin) {
        throw new Error('Method not implemented.');
    };
    BulletinProviderImpl.prototype.updateBulletin = function (id, bulletin) {
        throw new Error('Method not implemented.');
    };
    BulletinProviderImpl.prototype.removeBulletin = function (id) {
        throw new Error('Method not implemented.');
    };
    BulletinProviderImpl.prototype.getAvailableBulletin = function () {
        throw new Error('Method not implemented.');
    };
    BulletinProviderImpl.prototype.markAsRead = function (id) {
        throw new Error('Method not implemented.');
    };
    BulletinProviderImpl.prototype.stopAllMonitor = function () {
        throw new Error('Method not implemented.');
    };
    BulletinProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.log('init# env:', env);
        return Promise.resolve();
    };
    BulletinProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    return BulletinProviderImpl;
}());
exports.BulletinProviderImpl = BulletinProviderImpl;
//# sourceMappingURL=BulletinProviderImpl.js.map